<div class="taskUI">
  <div class="table-title">Completed Tasks</div>

  <profile-task-table [data]="tasks" [isMobile]="isMobile" [showStatus]="showStatus"></profile-task-table>

  <div *ngIf="total > 0 && total > pageSize" class="profile-paginator">
    <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" aria-label="Select page" (page)="changePage($event)"> </mat-paginator>
  </div>
</div>
